export const superHeroSelect = () => {
  function showLinks(id) {
    $(`.css--superhero__link-list`).removeClass("active");
    $(`.css--superhero__link-list[data-link-group="${id}"]`).addClass("active");
  }

  const dropdown = $(".css--superhero__dropdown-active");

  dropdown.on("click touch", function (e) {
    e.preventDefault();
    e.stopPropagation();

    dropdown.toggleClass("is-active");

    if (
      $(e.target).hasClass("css--superhero__dropdown-active") &&
      $(".css--superhero__dropdown-list").hasClass("show")
    ) {
      $(".css--superhero__dropdown-list").removeClass("show");
    } else {
      $(".css--superhero__dropdown-list").addClass("show");
    }
  });

  $(".css--superhero__dropdown-list li").on("click touch", function (e) {
    $(".css--superhero__dropdown-list li").removeClass("active");
    $(this).addClass("active");
    $(".css--superhero__dropdown-active").text($(this).text());
    const id = $(this).data("id");
    showLinks(id);
    dropdown.toggleClass("is-active");
  });

  $(document).on("click touch", function (e) {
    $(".css--superhero__dropdown-list").removeClass("show");
  });

  showLinks(0);
};
